const getMediaDownloadPath = require("./getMediaDownloadPath");

module.exports = function transformResourcesData(entity) {
	const { attributes, id, type, relationships } = entity;
	let data = {
		id,
		type,
		title: attributes.title,
		media: [],
	};
	if (
		relationships.field_media &&
		relationships.field_media.data &&
		Array.isArray(relationships.field_media.data)
	) {
		let valid_formats = [
			"url",
			"document",
			"pdf",
			"jpg",
			"jpeg",
			"png",
			"ppt",
			"pptx",
			"xls",
			"xlsx",
		];
		data.media = relationships.field_media.data.map((media_rel) => {
			let url = getMediaDownloadPath(media_rel);
			let title = media_rel.attributes.name;
			let ext = title.split(".").pop();
			let format = attributes.field_icon
				? attributes.field_icon
				: valid_formats.includes(ext)
				? ext
				: "document";
			let m = {
				id: media_rel.id,
				title,
				url: url.uri,
				external: url.external,
				format,
			};
			return m;
		});
	}
	return data;
};
